module.exports = __webpack_public_path__ + "media/images/default-c259060b21f2154bb282b1b65a9e563a.jpeg";